import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalContext";

const ProtectedRoute = ({ allowedRoles }) => {
  const { user } = useContext(GlobalContext);
  const location = useLocation();

  if (!user) {
    return (
      <Navigate to="/gateway" replace state={{ from: location.pathname }} />
    );
  }

  if (
    Array.isArray(allowedRoles) &&
    allowedRoles.length > 0 &&
    !allowedRoles.includes(user?.role)
  ) {
    return <Navigate to="/access-denied" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
